import axios from 'axios'

export const configMultipart = {
  headers: {
    'Content-Type': 'multipart/form-data',
    Accept: 'application/json',
    Authorization: `Bearer ${localStorage.getItem('currentUserKey')}`
  }
}

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL
})

instance.interceptors.request.use(async config => {
  if (localStorage.getItem('currentUserKey')) {
    config.headers.Accept = 'application/json'
    config.headers.Authorization = `Bearer ${localStorage.getItem('currentUserKey')}`
  }

  return config
}, error => error)

const getList = (api, params = {}) => {
  return instance.get(`/${api}`, { params })
}

const getItem = (api, id, params = {}) => {
  return instance.get(`/${api}/${id}`, { params })
}

const createItem = (api, data = {}, params = {}) => {
  return instance.post(`/${api}`, data, { params })
}

const updateItem = (api, id, data = {}, params = {}) => {
  return instance.put(`/${api}/${id}`, data, { params })
}

const sendEmail = (api, id, data = {}) => {
  return instance.post(`/${api}/${id}/send`, data)
}

const deleteItem = (api, id) => {
  return instance.delete(`/${api}/${id}`)
}

const DELETERequestItemArray = (api, itemArray) => {
  return axios.all(itemArray.map(item => deleteItem(api, item.id)))
}

const postFiles = (api, id, files) => {
  return instance.post(
    `/${api}/${id}/files`,
    files,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'application/json',
        Authorization: `Bearer ${localStorage.getItem('currentUserKey')}`
      }
    })
}

const removeFiles = (api, id, files) => {
  return instance.put(`/${api}/${id}/remove-files`, files)
}

export {
  instance,

  getList,
  getItem,

  createItem,
  updateItem,
  sendEmail,
  deleteItem,
  DELETERequestItemArray,

  postFiles,
  removeFiles
}
